import { usePointsBalanceStatement } from '@/features/points-management/points-balance-statement/hooks/usePointsBalanceStatement';
import { PointsBalanceStatementTable } from '@/features/points-management/points-balance-statement/table';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum([
    'transactionId',
    'transactionDate',
    'transactionType',
    'totalClubs',
    'user',
    'totalPrice',
    'totalCommissionAmt',
    'remarks',
    'debit',
    'credit',
    'balance',
  ]),
  desc: z.boolean(),
});

const pointsBalanceStatementSearchSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),
});

export const Route = createFileRoute('/(app)/points-management/points-balance-statement/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => pointsBalanceStatementSearchSchema.parse(search),
});

function RouteComponent() {
  const { pointsBalanceStatementData } = usePointsBalanceStatement();
  return <PointsBalanceStatementTable data={pointsBalanceStatementData} />;
}
